import React, {FC, MouseEventHandler, ReactNode} from "react";
import {MdAttachFile} from "react-icons/md";

interface CustomIconClipProps {
    children?: ReactNode;
}

const CustomIconClip: FC<CustomIconClipProps> = ({}: CustomIconClipProps) => {
    return (
        <div className="transform rotate-45">
            <MdAttachFile size={24}/>
        </div>
    );
};

export {CustomIconClip};

